export default __webpack_public_path__ + "static/media/about-team-25.9aaa4e31.jpg";